import { BaseService } from './base-service';

class CustomService extends BaseService {
  /**
   * @brief 删除自定义数据
   * @param params Object
   * @return {*}
   */
  deleteCustomData(params) {
    return this.request({
      method: 'GET',
      url: `/dynamic/entity/data/remove`,
      params
    });
  }
  /**
   * @brief 作废自定义数据
   * @param params Object
   * @return {*}
   */
  abandonCustomData(params) {
    return this.request({
      method: 'GET',
      url: `/dynamic/entity/data/abandon`,
      params
    });
  }
  /**
   * @brief 转移自定义数据
   * @param data Object
   * @return {*}
   */
  transferCustomData(data) {
    return this.request({
      method: 'POST',
      url: `/dynamic/entity/transferData`,
      data
    });
  }
  /**
   * @brief 单字段批量查重
   * @param data Object
   * @return {*}
   */
  fieldVerify(data) {
    return this.request({
      method: 'POST',
      url: `/batch/field/verify`,
      data
    });
  }
  /**
   * @brief 单字段批量编辑
   * @param data Object
   * @return {*}
   */
  fieldEdit(data) {
    return this.request({
      method: 'POST',
      url: `/batch/field/edit`,
      data
    });
  }
}

export const customService = new CustomService();
